import { Eye, ChevronDown } from "lucide-react";
import { useState, useRef, useEffect } from "react";

export default function ViewAsSelector({ user, viewAsRole, setViewAsRole }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const roles = [
    { value: null, label: "Admin", shortLabel: "👑", color: "bg-red-600" },
    { value: "team_captain", label: "Captain", shortLabel: "⚽", color: "bg-blue-600" },
    { value: "member", label: "Member", shortLabel: "👤", color: "bg-gray-600" },
    { value: "merchant", label: "Merchant", shortLabel: "🏪", color: "bg-purple-600" }
  ];

  const currentView = roles.find(r => r.value === viewAsRole) || roles[0];

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Only show for admins/convenors
  if (!user || !["convenor", "captain"].includes(user.role)) {
    return null;
  }

  return (
    <div className="fixed bottom-4 left-4 z-50" ref={dropdownRef}>
      {/* Compact toggle button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center gap-1.5 px-2 py-1 rounded-full shadow-lg text-white text-xs font-medium transition-all hover:scale-105 ${currentView.color}`}
        title="Switch view mode"
      >
        <Eye className="w-3 h-3" />
        <span>{currentView.shortLabel}</span>
        <ChevronDown className={`w-3 h-3 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {/* Dropdown menu */}
      {isOpen && (
        <div className="absolute bottom-full left-0 mb-2 bg-slate-800 rounded-lg shadow-xl border border-slate-700 overflow-hidden min-w-[120px]">
          <div className="px-2 py-1 border-b border-slate-700">
            <span className="text-[10px] text-slate-400 uppercase tracking-wider">View As</span>
          </div>
          {roles.map(role => (
            <button
              key={role.value || "admin"}
              onClick={() => {
                setViewAsRole(role.value);
                setIsOpen(false);
              }}
              className={`w-full px-3 py-1.5 text-left text-xs flex items-center gap-2 hover:bg-slate-700 transition-colors ${
                viewAsRole === role.value ? 'bg-slate-700 text-white' : 'text-slate-300'
              }`}
            >
              <span>{role.shortLabel}</span>
              <span>{role.label}</span>
              {viewAsRole === role.value && <span className="ml-auto">✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
